import axios from "axios";
 
const API_URL_REGISTER = "/user/register";
const API_URL_VERIFICATION = "/user/sendverification";
const API_URL_NEWEMAILVERIFICATION = "/user/reset/email";
const API_URL_RESETVERIFICATION = "/user/resetverification";
const API_URL_LOGIN = "/user/login";
const API_URL_CONTACTUS = "/user/contactus";
const API_URL_ISLOGGEDIN = "/user/isloggedin";
const API_URL_ADDLISTING = "/user/property/add";
const API_URL_EDITLISTING = "/user/property/update";
const API_URL_GETLISTING = "/user/property/get/";
const API_URL_GETUSERLISTING = "/user/property/getuserdata/";
const API_URL_GETALLLISTING = "/user/property/getalllisting/";
const API_URL_POSTSIMILARPROP = "/user/property/postsimilarprop/";
const API_URL_GETALLMESSAGES = "/user/chat";
const API_URL_GETSELECTEDMESSAGE = "/user/chat/room";
const API_URL_POSTMSGATTACHMENT = "/user/chat/upload";
// const API_URL_GETUSER = '/user/search'
const API_URL_GETSEARCH = "/user/s";
const API_URL_POSTFAVORITESERVICE = "/user/favorite";
const API_URL_POSTEMAILLISTSERVICE = "/user/subEmail";
const API_URL_GETFAVORITESERVICE = "/user/favorites";
const API_URL_POSTPROFILEINFO = "/user/profile/info";
const API_URL_POSTPROFILEEMAIL = "/user/profile/email";
const API_URL_POSTPROFILEPASS = "/user/profile/pass";
const API_URL_PASSWORDRESET = "/user/password/reset";
const API_URL_VERIFYCODE = "/user/verify/code";
const API_URL_REPORTPOST = "/user/reportpost";
const API_URL_POSTPROFILEPIC = "/user/profile/pic";
const API_URL_GETNOTIFICATION = "/user/notification";
const API_URL_POSTCHANGEAVAILABLE = "/user/profile/available";
const API_URL_POSTVIEW = "/user/view";
const API_URL_DELETEACCOUNT = "/user/deleteaccount";
const API_URL_ip = "/user/ip";
const API_URL_DELETEHOME = "/user/property/delete";
const API_URL_GET_FAQ_WITH_ID = "/user/faq/get/id";
//register user

const API_URL_GET_FAQ_CATEGORY = "/user/faq/category/get";

const getFaqCategoryService = async () => {
  const response = await axios.get(API_URL_GET_FAQ_CATEGORY);

  if (response.data) {
    return response.data;
  }
};

const registerService = async (userData) => {
  const response = await axios.post(API_URL_REGISTER, userData);

  return response.data;
};
const verificationService = async (userData) => {
  const response = await axios.post(API_URL_VERIFICATION, userData);

  return response.data;
};
const newEmailVerificationService = async (userData) => {
  const response = await axios.post(API_URL_NEWEMAILVERIFICATION, userData);

  return response.data;
};
const resetVerificationService = async (userData) => {
  const response = await axios.post(API_URL_RESETVERIFICATION, userData);

  return response.data;
};

//login user

const loginService = async (userData) => {
  const response = await axios.post(API_URL_LOGIN, userData, {
    withCredentials: true,
  });

  return response.data;
};
//contact us

const contactUsService = async (userData) => {
  const response = await axios.post(API_URL_CONTACTUS, userData);
  return response.data;
};

//login user

const isLoggedInService = async () => {
  const response = await axios.get(API_URL_ISLOGGEDIN, {
    withCredentials: true,
  });
  return response.data;
};

//addListing

const addListingService = async (homeData) => {
  const response = await axios.post(API_URL_ADDLISTING, homeData);

  if (response.data) {
    return response.data;
  }
};

//editListing
const editListingService = async (homeData) => {
  const response = await axios.put(API_URL_EDITLISTING, homeData);

  if (response.data) {
    return response.data;
  }
};

//getListings

const getListingService = async (id) => {
  const response = await axios.get(API_URL_GETLISTING, {
    params: { id },
  });
  if (response.data) {
    return response.data;
  }
};
//getUserListing

const getUserListingService = async () => {
  const response = await axios.get(API_URL_GETUSERLISTING);
  if (response.data) {
    return response.data;
  }
};

//getAllListing

const getAllListingService = async (location) => {
  const response = await axios.post(API_URL_GETALLLISTING, location, {
    withCredentials: true,
  });
  if (response.data) {
    return response.data;
  }
};
const postSimilarPropService = async (homeType) => {
  const response = await axios.post(API_URL_POSTSIMILARPROP, homeType, {
    withCredentials: true,
  });
  if (response.data) {
    return response.data;
  }
};
//getAllMessagesService

const getAllMessagesService = async () => {
  const response = await axios.get(API_URL_GETALLMESSAGES, {
    withCredentials: true,
  });
  if (response.data) {
    return response.data;
  }
};

//getSelectedMessagesService

const getSelectedMessageService = async (room) => {
  const response = await axios.get(API_URL_GETSELECTEDMESSAGE, {
    params: { room },
  });
  if (response.data) {
    return response.data;
  }
};

const postMsgAttachmentService = async (userData) => {
  const response = await axios.post(API_URL_POSTMSGATTACHMENT, userData, {
    withCredentials: true,
  });
  return response.data;
};

const getSearch = async (currentPostion) => {
  const response = await axios.get(API_URL_GETSEARCH, {
    params: { currentPostion },
  });
  if (response.data) { 
    return response.data;
  }
};

//favorite

// post favorite

const postFavoriteService = async (userData) => {
  const response = await axios.post(API_URL_POSTFAVORITESERVICE, userData, {
    withCredentials: true,
  });
  return response.data;
};

const postEmailService = async (userData) => {
  const response = await axios.post(API_URL_POSTEMAILLISTSERVICE, userData);

  return response.data;
};

// get favorite

const getFavoriteService = async () => {
  const response = await axios.get(API_URL_GETFAVORITESERVICE, {
    withCredentials: true,
  });
  return response.data;
};

const postProfilePicService = async (formData) => {
  const response = await axios.post(API_URL_POSTPROFILEPIC, formData, {
    withCredentials: true,
  });

  return response.data;
};

const postProfileInfoService = async (formData) => {
  const response = await axios.post(API_URL_POSTPROFILEINFO, formData, {
    withCredentials: true,
  });

  return response.data;
};
const postProfileEmailService = async (formData) => {
  const response = await axios.post(API_URL_POSTPROFILEEMAIL, formData, {
    withCredentials: true,
  });

  return response.data;
};
const postProfilePassService = async (formData) => {
  const response = await axios.post(API_URL_POSTPROFILEPASS, formData, {
    withCredentials: true,
  });

  return response.data;
};
const postPasswordResetService = async (formData) => {
  const response = await axios.post(API_URL_PASSWORDRESET, formData);

  return response.data;
};
const postVerifyCodeService = async (formData) => {
  const response = await axios.post(API_URL_VERIFYCODE, formData);

  return response.data;
};

const postReportPostService = async (formData) => {
  const response = await axios.post(API_URL_REPORTPOST, formData);

  return response.data;
};

//notification
const getNotificationService = async () => {
  const response = await axios.get(API_URL_GETNOTIFICATION, {
    withCredentials: true,
  });
  return response.data;
};
//Delete Home
const deleteHomeService = async (userData) => {
  const response = await axios.post(API_URL_DELETEHOME, userData, {
    withCredentials: true,
  });

  return response.data;
};
const deleteAccountService = async (userData) => {
  const response = await axios.post(API_URL_DELETEACCOUNT, userData, {
    withCredentials: true,
  });

  return response.data;
};
const ipService = async () => {
  const response = await axios.get(API_URL_ip);

  return response.data;
};

// post view

const postViewService = async (userData) => {
  const response = await axios.post(API_URL_POSTVIEW, userData);
  return response.data;
};

const getViewService = async () => {
  const response = await axios.get(API_URL_POSTVIEW, {
    withCredentials: true,
  });
  return response.data;
};

const logoutService = async () => {
  const response = await axios.delete("/api/logout", {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
    },
  });

  localStorage.removeItem("redirectUrl");

  return response.data;
};

//CHANGE AVAILABLE

const postChangeAvailableService = async (formData) => {
  const response = await axios.post(API_URL_POSTCHANGEAVAILABLE, formData, {
    withCredentials: true,
  });

  return response.data;
};

const getFaqWithIdService = async (id) => {
  const response = await axios.get(`${API_URL_GET_FAQ_WITH_ID}/${id}`);

  if (response.data) {
    return response.data;
  }
};

// // get favorite

// const getFavoriteService =async () =>{
//     const response=await axios.get(API_URL_GETFAVORITESERVICE,{
//         withCredentials: true
//     })
//     return (response.data)
// }

const authService = {
  registerService,
  getFaqWithIdService,
  verificationService,
  deleteHomeService,
  loginService,
  contactUsService,
  addListingService,
  editListingService,
  getListingService,
  getUserListingService,
  getAllListingService,
  getAllMessagesService,
  getSelectedMessageService,
  getSearch,
  postFavoriteService,
  getFavoriteService,
  isLoggedInService,
  postProfilePicService,
  postProfileInfoService,
  postProfileEmailService,
  postProfilePassService,
  getNotificationService,
  postViewService,
  getViewService,
  logoutService,
  postSimilarPropService,
  deleteAccountService,
  postEmailService,
  ipService,
  resetVerificationService,
  postPasswordResetService,
  postReportPostService,
  postChangeAvailableService,
  newEmailVerificationService,
  postVerifyCodeService,
  postMsgAttachmentService,
  getFaqCategoryService,
};
export default authService;
